import React from "react";
import LojaModel from "../model/LojaModel";
import { Redirect } from "react-router";
import NavegadorUtil from "../util/NavegadorUtil";
import { Link } from "react-router-dom";

type SeletorLojaProps = {
  loja: LojaModel | null;
};

type SeletorLojaState = {
  loja: LojaModel | null;
};

class SeletorLoja extends React.Component<SeletorLojaProps, SeletorLojaState> {
  constructor(props: SeletorLojaProps) {
    super(props);

    this.state = {
      loja: null,
    };
  }

  async componentDidMount(): Promise<any> {
    if (!this.props.loja) {
      return (
        <Redirect to={`/lojas?returnUrl=${window.location.hash}`}></Redirect>
      );
    }
  }

  render(): any {
    const { loja } = this.props;
    const retUrl: string = window.location.hash;

    if (loja) {
      return (
        <div className="store">
          <p>
            <Link to={NavegadorUtil.getUrl(`/lojas?returnUrl=${retUrl}`)}>
              <i className="fas fa-map-marker-alt marker"></i> {loja.nome}{" "}
              <i className="fas fa-sort-down"></i>
            </Link>
          </p>
        </div>
      );
    } else {
      return null;
    }
  }
}

export default SeletorLoja;
